export const cupSmallCorrectFitCaptions = {
    labels: [
    {
      tick: 10,
      copy: "Stabilise band, pull all of breasts into cup"
    },
    {
      tick: 14,
      copy: "Sweep"
    }
  ]   
};

export const cupLargeCorrectFitCaptions = {
    labels: [
    {
      tick: 17,
      copy: "Stabilise band, pull all of breasts into cup"
    },
    {
      tick: 20,
      copy: "Sweep"
    }
  ]   
};

export const bandCorrectFitCaptions = {
    labels: [
    {
      tick: 5,
      copy: "Feels firm and has resistance when band pulled away from trunk"
    },
    {
      tick: 10,
      copy: "Stays in place when you raise your arms"
    }
  ]   
};

export const bandTooBigCaptions = {
    labels: [
    {
      tick: 8,
      copy: "Feels loose with no resistance when band pulled away from trunk"
    },
    {
      tick: 16,
      copy: "Slides up and down when you raise your arms"
    }
  ]   
};

export const strapsCorrectFitCaptions = {
    labels: [
    {
      tick: 3,
      copy: "Feels firm but comfortable on shoulders"
    },
    {
      tick: 7,
      copy: "Does NOT easily slide off shoulders"
    },
    {
      tick: 12,
      copy: "Firm resistance when lifting strap away from shoulders"
    }
  ]   
};

export const strapsTooBigCaptions = {
    labels: [
    {
      tick: 3,
      copy: "Feels loose on shoulders"
    },
    {
      tick: 6,
      copy: "Easily slides off shoulders"
    },
    {
      tick: 11,
      copy: "Loose resistance when lifting strap away from shoulders"
    }
  ]   
};